module.exports = __webpack_public_path__ + "img/remittance_dashbpard.91d07fb0.svg";